import { __module as e } from "../../../_virtual/isDecimal.js";
import { m as a } from "./util/merge.js";
import { a as t } from "./util/assertString.js";
import { i as l } from "./util/includes.js";
import "./alpha.js";
import { __exports as r } from "../../../_virtual/alpha.js";
!function (e, o) {
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = function (e, a) {
    if ((0, c.default)(e), (a = (0, i.default)(a, d)).locale in r.decimal) {
      var t;
      return !(0, s.default)(m, e.replace(/ /g, "")) && (t = a, new RegExp("^[-+]?([0-9]+)?(\\".concat(r.decimal[t.locale], "[0-9]{").concat(t.decimal_digits, "})").concat(t.force_decimal ? "" : "?", "$"))).test(e);
    }
    throw Error("Invalid locale '".concat(a.locale, "'"));
  };
  var i = u(a),
    c = u(t),
    s = u(l);
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var d = {
      force_decimal: !1,
      decimal_digits: "1,",
      locale: "en-US"
    },
    m = ["", "-", "+"];
  e.exports = o.default, e.exports.default = o.default;
}(e, e.exports);
var o = e.exports;
export { o as i };